import * as React from 'react';
import { gql } from '@apollo/client';
import {
  BulkDeleteTimeslotsModalController,
  BulkDeleteTimeslotsModalControllerProps
} from './BulkDeleteTimeslotsModal.controller';
import { useBulkDeleteTimeslotsMutation } from '../../../../models/graphql';

export type BulkDeleteTimeslotsModalApolloProps = Omit<
  BulkDeleteTimeslotsModalControllerProps,
  'bulkDeleteTimeslots'
> & {
  // ...
};

gql`
  mutation BulkDeleteTimeslots($timeslotIds: [ID!]!) {
    bulkDeleteTimeslots(timeslotIds: $timeslotIds)
  }
`;

export const BulkDeleteTimeslotsModalApollo = (props: BulkDeleteTimeslotsModalApolloProps): JSX.Element => {
  const [bulkDeleteTimeslots] = useBulkDeleteTimeslotsMutation();

  const controllerProps: BulkDeleteTimeslotsModalControllerProps = {
    ...props,
    bulkDeleteTimeslots
  };

  return <BulkDeleteTimeslotsModalController {...controllerProps} />;
};
